import React from 'react'

const MyAttendance = () => {
  return (
    <div>MyAttendance</div>
  )
}

export default MyAttendance